import { endpoint } from "views/pages/manage/common/constant";
import {
  fetchAllPostPromisedData,
  fetchAllPromisedData,
} from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";

export const validateTransferStudent = (request) => {
  return fetchAllPostPromisedData(
    `${endpoint.studentTransfer.transferValidations}`,
    request
  );
};

export const fetchStudentSummary = (applicationId, businessAreaDispValue) => {
  const url = `${endpoint.getFeeBreakupWithPaymentDetails}/${applicationId}?businessArea=${businessAreaDispValue}`;
  return fetchAllPromisedData(url, true);
};

 const createTransferApi = (request) => {
  return fetchAllPostPromisedData(
    `${endpoint.studentTransfer.createTransferRequest}`,
    request
  );
};


export const transferApi = (request) => {
 return  request?.id ? updateTransferApi(request): createTransferApi(request)
};

 const updateTransferApi = (request) => {
  return fetchAllPostPromisedData(
    `${endpoint.studentTransfer.updateTransferDetails}`,
    request,
    "put"
  );
};

export const fetchAdjustmentSummaryApi = (request) => {
  return fetchAllPostPromisedData(
    `${endpoint.studentTransfer.adjustment}`,
    request
  );
};
